// import React from "react";
// import search from '../../src/assets/images/all/search.svg';


// const Footer = () => {
//   return (
//     <>
//       <footer className="footer-section">
//         <div className="container container-two">
//           <div className="row gy-5">
//             <div className="col-xl-6 col-sm-6">
//               <div className="position-relative mb-5">
//                 <div className="search-box">
//                   <input
//                     type="text"
//                     className="common-input common-input--lg pill shadow-sm auto-suggestion-input"
//                     placeholder="Search"
//                   />
//                   <button
//                     type="submit"
//                     className="btn btn-main spl_button btn-icon icon border-0"
//                     style={{ padding: '0.5rem' }} // Optional padding adjustment
//                   >
//                     <img
//                       src={search}
//                       alt="Search"
//                       style={{
//                         width: '30px', // Increase the width of the icon
//                         height: '30px', // Increase the height of the icon
//                       }}
//                     />
//                   </button>
//                 </div>
//               </div>

//               <div className="row">
//                 <div className="col-sm-5 col-xs-6">
//                   <div className="footer-widget">
//                     <ul className="footer-lists">
//                       <li className="footer-lists__item">
//                         <a href="/" className="footer-lists__link">Home</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="/course" className="footer-lists__link">Courses</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="/Feed" className="footer-lists__link">Feed</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="/teacher" className="footer-lists__link">Teachers</a>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="col-sm-6 col-xs-6 ps-xl-5">
//                   <div className="footer-widget">
//                     <ul className="footer-lists">
//                       <li className="footer-lists__item">
//                         <a href="#" className="footer-lists__link">About Us</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="#" className="footer-lists__link">Payment</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="#" className="footer-lists__link">My Profile</a>
//                       </li>
//                       <li className="footer-lists__item">
//                         <a href="/institute" className="footer-lists__link">Institutes</a>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>

//                 <div className="footer-widget mt-4">
//                   <h3>Follow us on</h3>
//                   <div className="footer-widget__social">
//                     <ul className="social-icon-list">
//                       <li className="social-icon-list__item">
//                         <a href="https://www.facebook.com" className="social-icon-list__link flx-center">
//                           <i className="fab fa-facebook-f"></i>
//                         </a>
//                       </li>
//                       <li className="social-icon-list__item">
//                         <a href="https://www.youtube.com" className="social-icon-list__link flx-center">
//                           <i className="fab fa-youtube"></i>
//                         </a>
//                       </li>
//                       <li className="social-icon-list__item">
//                         <a href="https://www.linkedin.com" className="social-icon-list__link flx-center">
//                           <i className="fab fa-linkedin-in"></i>
//                         </a>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-xl-5 offset-xl-1 col-sm-6">
//               <div className="footer-widget">
//                 <div className="map-box mb-30 mt-5">
//                   <li className="footer-lists__item">
//                     <a href="#" className="footer-lists__link">Location</a>
//                   </li>
//                   <iframe
//                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.330999415546!2d78.44399507462819!3d17.44386460117675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb917f6ecb6987%3A0x7d6d85b768a4c33b!2sFg%20Designs!5e0!3m2!1sen!2sin!4v1707451998655!5m2!1sen!2sin"
//                     width="100%"
//                     height="300px"
//                     style={{ border: 0 }}
//                     allowFullScreen=""
//                     loading="lazy"
//                     referrerPolicy="no-referrer-when-downgrade"
//                   ></iframe>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Footer;


import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import lightLogo from '../../src/assets/img/logo/logo-light.png';
import search from '../../src/assets/images/all/search.svg';

const Footer = () => {
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      message: ""
    });
    const [successMessage, setSuccessMessage] = useState(""); // State for success message
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
  
    // Handle input change
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    };
  
    // Handle form submission
    const handleSubmit = async (e) => {
      e.preventDefault(); // Prevent page reload
      setSuccessMessage(""); // Reset messages
        setErrorMessage("");
  
      try {
        const response = await axios.post(`${API_BASE_URL}/saveEnquiryData`, formData, {
            headers: {
              "Content-Type": "application/json",
            },
          });
    
          if (response.status === 201) {
            setSuccessMessage("Enquiry submitted successfully!");
            setFormData({ name: "", email: "" }); // Reset form
          } else {
            setErrorMessage("Failed to submit enquiry. Please try again.");
          }
      } catch (error) {
        console.error("Error:", error);
        setErrorMessage("Failed to submit enquiry. Please try again.");
      }
    };
  
    return (
      <div style={{ overflowY: "hidden"}}>
        <footer class="footer-area">
            <button
        className="btn btn-primary enquire_now"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      >
        Enquire Now
      </button>

      {/* Offcanvas Form */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            Enquire <span className="text-warning">Now</span>
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        {successMessage && <div style={{ color: "green", marginBottom: "10px" }}>{successMessage}</div>}
        {errorMessage && <div style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</div>}
        <div className="offcanvas-body">
          <form className="row contact-form" onSubmit={handleSubmit}>
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name} 
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email} 
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="phone"
                  className="form-control"
                  name="phone"
                  value={formData.phone} 
                  onChange={handleChange}
                  placeholder="Your Contact Number"
                  required
                />
              </div>
            </div>
            {/* <div className="col-md-12">
              <div className="form-group">
                <select className="form-select form-control" aria-label="city">
                  <option selected>City</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
              </div>
            </div> */}
            {/* <div className="col-md-12">
              <div className="form-group">
                <select className="form-select form-control" aria-label="courses">
                  <option selected>Courses</option>
                  <option value="1">MBA</option>
                  <option value="2">BBA</option>
                  <option value="3">Btech</option>
                </select>
              </div>
            </div> */}
            {/* <div className="col-md-12">
              <div className="form-group">
                <select className="form-select form-control" aria-label="college">
                  <option selected>College for Admission</option>
                  <option value="1">MBA</option>
                  <option value="2">BBA</option>
                  <option value="3">Btech</option>
                </select>
              </div>
            </div> */}
            <div className="col-md-12">
              <div className="form-group">
                <textarea
                  name="message"
                  cols="30"
                  rows="2"
                  className="form-control"
                  placeholder="Write Your Message"
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary mt-2">
              Submit <i className="far fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </div>
        <div class="footer-shape">
            <img src={lightLogo} alt="" />
        </div>
        {/* <div class="footer-widget">
          
            <div class="container">
                <div class="row footer-widget-wrapper pt-100 pb-70">
                    <div class="col-md-6 col-lg-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">MBA</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)">Top MBA Colleges</a></li>
                                <li><a href="javascript:void(0)"> MBA Colleges</a></li>
                                <li><a href="javascript:void(0)"> Executive MBA Colleges</a></li>
                                <li><a href="javascript:void(0)"> MBA Exams</a></li>
                                <li><a href="javascript:void(0)"> CAT</a></li>
                                <li><a href="javascript:void(0)"> MAT</a></li>
                                 <li><a href="javascript:void(0)"> Online MBA</a></li>
                                 <li><a href="javascript:void(0)">MBA College Predictors</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Engineering</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Engineering</a></li>
                                 <li><a href="javascript:void(0)"> Top Engineering Colleges</a></li>
                                <li><a href="javascript:void(0)"> Engineering Colleges</a></li>
                                <li><a href="javascript:void(0)"> Engineering Exams</a></li>
                                <li><a href="javascript:void(0)"> JEE Main</a></li>
                                <li><a href="javascript:void(0)"> JEE Advanced</a></li>
                                <li><a href="javascript:void(0)"> Engineering College Predictors</a></li>
                                
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Medicine</h4>
                            <ul class="footer-list">
                                 <li><a href="javascript:void(0)"> NEET UG</a></li>
                                 <li><a href="javascript:void(0)"> NEET PG</a></li>
                                <li><a href="javascript:void(0)"> NEET SS</a></li>
                                <li><a href="javascript:void(0)"> NEET MDS</a></li>
                                <li><a href="javascript:void(0)"> INI CET</a></li>
                                <li><a href="javascript:void(0)"> FMGE </a></li>
                                <li><a href="javascript:void(0)"> AIAPGET</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Other Courses</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Animation</a></li>
                                <li><a href="javascript:void(0)"> B.Com</a></li>
                                <li><a href="javascript:void(0)">B.Sc</a></li>
                                <li><a href="javascript:void(0)"> BBA</a></li>
                                <li><a href="javascript:void(0)"> CA</a></li>
                                <li><a href="javascript:void(0)"> Fashion Designing</a></li>
                                 <li><a href="javascript:void(0)"> Hotel Management</a></li>
                                 <li><a href="javascript:void(0)"> Law </a></li>
                            </ul>
                        </div>
                    </div>
                        <div class="col-md-6 col-lg-3 mt-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Resources</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Careers after 12th</a></li>
                                <li><a href="javascript:void(0)"> Courses After 12th</a></li>
                                <li><a href="javascript:void(0)">Education Boards</a></li>
                                <li><a href="javascript:void(0)"> Ask a Question</a></li>
                                <li><a href="javascript:void(0)"> Discussions</a></li>
                                
                            </ul>
                        </div>
                    </div>
                        <div class="col-md-6 col-lg-3 mt-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Study Abroad</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Study Abroad Home</a></li>
                                <li><a href="javascript:void(0)"> BTech abroad</a></li>
                                <li><a href="javascript:void(0)">MBA abroad</a></li>
                                <li><a href="javascript:void(0)"> MS abroad</a></li>
                                <li><a href="javascript:void(0)"> GRE</a></li>
                               
                            </ul>
                        </div>
                    </div>
                       <div class="col-md-6 col-lg-3 mt-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Padhai Dekho Online</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Animation</a></li>
                                <li><a href="javascript:void(0)"> B.Com</a></li>
                                <li><a href="javascript:void(0)">B.Sc</a></li>
                                <li><a href="javascript:void(0)"> BBA</a></li>
                                <li><a href="javascript:void(0)"> CA</a></li>
                                <li><a href="javascript:void(0)"> Fashion Designing</a></li>
                                 <li><a href="javascript:void(0)"> Hotel Management</a></li>
                                 <li><a href="javascript:void(0)"> Law </a></li>
                            </ul>
                        </div>
                    </div>
                        <div class="col-md-6 col-lg-3 mt-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Padhai Dekho Online</h4>
                            <ul class="footer-list">
                                <li><a href="javascript:void(0)"> Animation</a></li>
                                <li><a href="javascript:void(0)"> B.Com</a></li>
                                <li><a href="javascript:void(0)">B.Sc</a></li>
                                <li><a href="javascript:void(0)"> BBA</a></li>
                                <li><a href="javascript:void(0)"> CA</a></li>
                                <li><a href="javascript:void(0)"> Fashion Designing</a></li>
                                 <li><a href="javascript:void(0)"> Hotel Management</a></li>
                                 <li><a href="javascript:void(0)"> Law </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
        <div class="copyright">
            <div class="container">
                <div class="copyright-wrapper">
                    <div class="row">
                        <div class="col-md-6 align-self-center">
                            
                                <ul class="copyright-text">
                                    <li> <a href="/about">About Us   </a></li>
                                    <li>  <a href="/contact">Contact Us    </a></li>
                                    <li>  <a href="/terms">Terms & Conditions      </a></li>
                                    <li> <a href="/privacy">Privacy Policy</a></li>
                                    <li> <a href="/refund">Refund Policy</a></li>
                                </ul>
                        </div>
                        <div class="col-md-6 align-self-center">
                            
                            <p class="copyright-text text-right">
                              
                                &copy; Copyright  padhaidekho.com  All Rights Reserved.
                            </p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    </div>
    );
}

export default Footer;